/**
 * Routes
 */

// import VueCookies from 'vue-cookies'

// components
var Dashboard = resolve => require(['./views/Dashboard.vue'], resolve)
var NotFound = resolve => require(['./views/404.vue'], resolve)
var Login = resolve => require(['./views/Login.vue'], resolve)

module.exports = [
  // google login callback after a successful login
  { path: '/register', component: resolve => require(['./views/Register.vue'], resolve) },
  { path: '/login', component: Login },
  { name: '/user/oauth/check', path: '/user/oauth/check', component: resolve => require(['./views/Callback.vue'], resolve) },
  { path: '/forgot', component: resolve => require(['./views/Forgot.vue'], resolve) },
  { name: '/reset', path: '/reset/:id', component: resolve => require(['./views/Reset.vue'], resolve) },
    // user signup through invitation link
  {
    name: '/signup',
    path: '/signup/:id',
    component: resolve => require(['./views/Signup.vue'], resolve)
  },
  { path: '/', redirect: '/dashboard' },
  { path: '/dashboard', component: Dashboard },
  {
    path: '/products',
    component: resolve => require(['./views/product/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/product/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/product/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-product',
        component: resolve => require(['./views/product/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/clients',
    component: resolve => require(['./views/client/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/client/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/client/add.vue'], resolve)
      },
      {
        name: 'edit-client',
        path: 'edit/:id',
        component: resolve => require(['./views/client/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/product-categories',
    component: resolve => require(['./views/product_category/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/product_category/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/product_category/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-productcategory',
        component: resolve => require(['./views/product_category/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/product-packings',
    component: resolve => require(['./views/product_packing/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/product_packing/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/product_packing/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-productpacking',
        component: resolve => require(['./views/product_packing/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/product-brands',
    component: resolve => require(['./views/product-brand/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/product-brand/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/product-brand/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-product-brand',
        component: resolve => require(['./views/product-brand/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/product-mapping-codes',
    component: resolve => require(['./views/product-mapping-code/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/product-mapping/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/product-mapping-code/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-product-mapping-code',
        component: resolve => require(['./views/product-mapping-code/edit.vue'], resolve)
      },
      {
        path: 'filter',
        name: 'filter-product-mapping-code',
        component: resolve => require(['./views/product-mapping-code/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/product-price-lists',
    component: resolve => require(['./views/product-price-list/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/product-price-list/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/product-price-list/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-product-price-list',
        component: resolve => require(['./views/product-price-list/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/promo-price-lists',
    component: resolve => require(['./views/promo-price-list/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/promo-price-list/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/promo-price-list/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-promo-price-list',
        component: resolve => require(['./views/promo-price-list/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/visits',
    component: resolve => require(['./views/visits/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/visits/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/visits/add.vue'], resolve)
      },
      {
        path: 'bulk-add',
        component: resolve => require(['./views/visits/bulk_add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-visit',
        component: resolve => require(['./views/visits/edit.vue'], resolve)
      },
      {
        path: 'recurring-visit-add',
        component: resolve => require(['./views/visits/bulk_add_recurring.vue'], resolve)
      },



    ]
  },
  {
    path: '/visit-calendar',
    component: resolve => require(['./views/visits/template.vue'], resolve),
    children: [
    {
        path: '',
        component: resolve => require(['./views/visits/calendar_index.vue'], resolve)
    },
    ]
  },
  {
    path: '/retailers',
    component: resolve => require(['./views/retailers/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/retailers/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/retailers/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-retailers',
        component: resolve => require(['./views/retailers/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/locations',
    component: resolve => require(['./views/locations/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/locations/index.vue'], resolve)
      },
      {
        name: 'add-location',
        path: 'add',
        component: resolve => require(['./views/locations/add.vue'], resolve)
      },
      {
        name: 'edit-location',
        path: 'edit/:id',
        component: resolve => require(['./views/locations/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/location-map',
    component: resolve => require(['./views/location-map/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/location-map/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/tasks',
    component: resolve => require(['./views/task/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/task/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/task/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-task',
        component: resolve => require(['./views/task/edit.vue'], resolve)
      }
    ]
  },
  /*
   * Settings related routes
   */
  {
    path: '/settings',
    component: resolve => require(['./views/settings/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/settings/company-settings.vue'], resolve)
      },
      {
        path: 'add-region',
        component: resolve => require(['./views/settings/region/add.vue'], resolve)
      },
      {
        name: 'edit-region',
        path: 'edit-region/:id',
        component: resolve => require(['./views/settings/region/edit.vue'], resolve)
      },
      {
        path: 'add-location-grade',
        component: resolve => require(['./views/settings/location-grade/add.vue'], resolve)
      },
      {
        path: 'add-department',
        component: resolve => require(['./views/settings/department/add.vue'], resolve)
      },
      {
        name: 'edit-department',
        path: 'edit-department/:id',
        component: resolve => require(['./views/settings/department/edit.vue'], resolve)
      },
      {
        name: 'edit-location-grade',
        path: 'edit-location-grade/:id',
        component: resolve => require(['./views/settings/location-grade/edit.vue'], resolve)
      },
      {
        path: 'add-location-type',
        component: resolve => require(['./views/settings/location-type/add.vue'], resolve)
      },
      {
        name: 'edit-location-type',
        path: 'edit-location-type/:id',
        component: resolve => require(['./views/settings/location-type/edit.vue'], resolve)
      },
      {
        path: 'add-store-category',
        component: resolve => require(['./views/settings/store-category/add.vue'], resolve)
      },
      {
        name: 'edit-store-category',
        path: 'edit-store-category/:id',
        component: resolve => require(['./views/settings/store-category/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/profile',
    component: resolve => require(['./views/settings/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/profile.vue'], resolve)
      }
    ]
  },
  {
    path: '/store-model',
    component: resolve => require(['./views/store_model/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/store_model/index.vue'], resolve)
      },
      {
        name: 'add-store-model',
        path: 'add',
        component: resolve => require(['./views/store_model/add.vue'], resolve)
      },
      {
        name: 'edit-store-model',
        path: 'edit/:id',
        component: resolve => require(['./views/store_model/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/assign-retailers-price-lists',
    component: resolve => require(['./views/assign-retailers-price-lists/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/assign-retailers-price-lists/index.vue'], resolve)
      },
      {
        name: 'add-retailers-price',
        path: 'add',
        component: resolve => require(['./views/assign-retailers-price-lists/add.vue'], resolve)
      },
      {
        name: 'edit-retailers-price',
        path: 'edit',
        component: resolve => require(['./views/assign-retailers-price-lists/edit.vue'], resolve)
      },
      {
        name: 'edit-retailers-promo',
        path: 'editpromo',
        component: resolve => require(['./views/assign-retailers-price-lists/editpromo.vue'], resolve)
      },
      {
        name: 'add-retailers-promo',
        path: 'addpromo',
        component: resolve => require(['./views/assign-retailers-price-lists/addpromo.vue'], resolve)
      }
    ]
  },
  {
    path: '/store-model-locations',
    component: resolve => require(['./views/store_model_locations/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/store_model_locations/index.vue'], resolve)
      },
      {
        name: 'add-store-model-locations',
        path: 'add',
        component: resolve => require(['./views/store_model_locations/add.vue'], resolve)
      }
    ]
  },
  {
    path: '/client-retailers',
    component: resolve => require(['./views/client-retailer/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/client-retailer/index.vue'], resolve)
      },
      {
        name: 'add-client-retailer',
        path: 'add',
        component: resolve => require(['./views/client-retailer/add.vue'], resolve)
      }
    ]
  },
  {
    path: '/client-location',
    component: resolve => require(['./views/client-location/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/client-location/index.vue'], resolve)
      },
      {
        name: 'add-client-location',
        path: 'add',
        component: resolve => require(['./views/client-location/add.vue'], resolve)
      }
    ]
  },
  {
    path: '/merchandisers',
    component: resolve => require(['./views/merchandiser/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/merchandiser/index.vue'], resolve)
      },
      {
        name: 'add-merchandiser',
        path: 'add',
        component: resolve => require(['./views/merchandiser/add.vue'], resolve)
      },
      {
        name: 'edit-merchandiser',
        path: 'edit/:id',
        component: resolve => require(['./views/merchandiser/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/users',
    component: resolve => require(['./views/users/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/users/index.vue'], resolve)
      },
      {
        name: 'add-user',
        path: 'add',
        component: resolve => require(['./views/users/add.vue'], resolve)
      },
      {
        name: 'edit-user',
        path: 'edit',
        component: resolve => require(['./views/users/edit.vue'], resolve)
      },
      {
        name: 'invite-user',
        path: 'invite',
        component: resolve => require(['./views/users/invite.vue'], resolve)
      }
    ]
  },
  {
    path: '/roles',
    component: resolve => require(['./views/roles/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/roles/index.vue'], resolve)
      },
      {
        name: 'add-role',
        path: 'add',
        component: resolve => require(['./views/roles/add.vue'], resolve)
      },
      {
        name: 'edit-role',
        path: 'edit',
        component: resolve => require(['./views/roles/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/price-lists',
    component: resolve => require(['./views/price-list/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/price-list/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/price-list/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-price-list',
        component: resolve => require(['./views/price-list/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/visit-report',
    component: resolve => require(['./views/visit-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/visit-reports/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/visit-reports/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-visit-report',
        component: resolve => require(['./views/visit-reports/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/visit-report2',
    component: resolve => require(['./views/visit-reports-2/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/visit-reports-2/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/visit-reports-2/add.vue'], resolve)
      },
      {
        path: 'edit/:id',
        name: 'edit-visit-report2',
        component: resolve => require(['./views/visit-reports-2/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/retailer-reports',
    component: resolve => require(['./views/retailer-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/retailer-reports/index.vue'], resolve)
      },
      {
        path: 'view/:id/:taskid',
        name: 'view-retailer-report',
        component: resolve => require(['./views/retailer-reports/view.vue'], resolve)
      },
      {
        path: 'edit/:id/:taskid',
        name: 'edit-retailer-report',
        component: resolve => require(['./views/retailer-reports/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/photo-gallery-report',
    component: resolve => require(['./views/photo-gallery-report/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/photo-gallery-report/index.vue'], resolve)
      },
      {
        name: 'photos',
        path: 'photos',
        component: resolve => require(['./views/photo-gallery-report/view.vue'], resolve)
      }
    ]
  },
  {
    path: '/stock-take-photo-reports',
    component: resolve => require(['./views/stock-management-reports/stock-take-gallery-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/stock-management-reports/stock-take-gallery-reports/index.vue'], resolve)
      },
      {
        name: 'photos2',
        path: 'photos',
        component: resolve => require(['./views/stock-management-reports/stock-take-gallery-reports/view.vue'], resolve)
      }
    ]
  },
    //Alexia
  {
    path: '/machine-learning-pictures',
    component: resolve => require(['./views/machine-learning-pictures/stock-take-gallery-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/machine-learning-pictures/stock-take-gallery-reports/index.vue'], resolve)
      },
      {
        name: 'photos2',
        path: 'photos',
        component: resolve => require(['./views/machine-learning-pictures/stock-take-gallery-reports/view.vue'], resolve)
      }
    ]
  },
  {
    path: '/stock-take-reports',
    component: resolve => require(['./views/stock-take-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/stock-take-reports/index2.vue'], resolve)
      },
      {
        path: 'view/:id',
        name: 'view-stock-take-report',
        component: resolve => require(['./views/stock-take-reports/view.vue'], resolve)
      },
      {
        path: 'order-form/:id',
        name: 'view-order-form',
        component: resolve => require(['./views/stock-take-reports/order-form.vue'], resolve)
      }
    ]
  },
  {
    path: '/planogram-visit-reports',
    component: resolve => require(['./views/planogram-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/planogram-reports/index.vue'], resolve)
      },
      {
        path: 'view/:id',
        name: 'view-planogram-report',
        component: resolve => require(['./views/planogram-reports/view.vue'], resolve)
      },
      {
        path: 'view-smart/:id',
        name: 'view-smart-planogram-report',
        component: resolve => require(['./views/planogram-reports/view-smart.vue'], resolve)
      },
      {
        path: 'oos/:id',
        name: 'view-oos-report',
        component: resolve => require(['./views/planogram-reports/oos.vue'], resolve)
      }
    ]
  },
  {
    path: '/photo-gallery-reports',
    component: resolve => require(['./views/planogram-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/photo-gallery-reports/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/uncompleted-store-visits',
    component: resolve => require(['./views/uncompleted-store-visits/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/uncompleted-store-visits/index.vue'], resolve)
      },
      {
        path: 'view/:id',
        name: 'view-uncompleted-store-visits',
        component: resolve => require(['./views/uncompleted-store-visits/view.vue'], resolve)
      }
    ]
  },
  {
    path: '/announcements',
    component: resolve => require(['./views/announcement/template.vue'], resolve),
    children: [
      {
        name: 'all',
        path: 'all',
        component: resolve => require(['./views/announcement/index.vue'], resolve)
      },
      {
        name: 'add-announcement',
        path: 'add',
        component: resolve => require(['./views/announcement/add.vue'], resolve)
      },
      {
        name: 'update-announcement',
        path: 'update/:id',
        component: resolve => require(['./views/announcement/update.vue'], resolve)
      }
    ]
  },
  {
    path: '/promoter-rosters',
    component: resolve => require(['./views/promoter-rosters/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/promoter-rosters/index.vue'], resolve)
      },
      {
        name: 'add',
        path: 'add',
        component: resolve => require(['./views/promoter-rosters/add.vue'], resolve)
      },
      {
        name: 'add-bulk',
        path: 'add-bulk',
        component: resolve => require(['./views/promoter-rosters/add-bulk.vue'], resolve)
      },
      {
        name: 'edit-rosters',
        path: 'edit/:id',
        component: resolve => require(['./views/promoter-rosters/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/promoter-calendar',
    component: resolve => require(['./views/promoter-rosters/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/promoter-rosters/calendar_index.vue'], resolve)
      },
    ]
  },
  {
    path: '/non-clocked-employee-reports',
    component: resolve => require(['./views/non-clocked-employee-report/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/non-clocked-employee-report/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/promoters',
    component: resolve => require(['./views/promoter/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/promoter/index.vue'], resolve)
      },
      {
        name: 'add-promoters',
        path: 'add',
        component: resolve => require(['./views/promoter/add.vue'], resolve)
      },
      {
        name: 'edit-promoter',
        path: 'edit/:id',
        component: resolve => require(['./views/promoter/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/salesreport',
    component: resolve => require(['./views/salesreport/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/salesreport/index.vue'], resolve)
      },
      {
        name: 'add-salesreport',
        path: 'add',
        component: resolve => require(['./views/salesreport/add.vue'], resolve)
      },
      {
        name: 'edit-salesreport',
        path: 'edit/:id',
        component: resolve => require(['./views/salesreport/edit.vue'], resolve)
      },
      {
        name: 'view-salesreport',
        path: 'view/:id',
        component: resolve => require(['./views/salesreport/view.vue'], resolve)
      }
    ]
  },
  {
    path: '/stock-take-management-reports',
    component: resolve => require(['./views/stock-management-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/stock-management-reports/stock-take.vue'], resolve)
      },
      {
        name: 'view-stock-take',
        path: 'view-stock-take/:id',
        component: resolve => require(['./views/stock-management-reports/view-stock-take.vue'], resolve)
      }
    ]
  },
  {
    path: '/stock-receipt-management-reports',
    component: resolve => require(['./views/stock-management-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/stock-management-reports/stock-receipt.vue'], resolve)
      },
      {
        name: 'view-stock-receipt',
        path: 'view-stock-receipt/:id',
        component: resolve => require(['./views/stock-management-reports/view-stock-receipt.vue'], resolve)
      }
    ]
  },
  {
    path: '/stock-request-management-reports',
    component: resolve => require(['./views/stock-management-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/stock-management-reports/stock-request.vue'], resolve)
      },
      {
        name: 'view-stock-request',
        path: 'view-stock-request/:id',
        component: resolve => require(['./views/stock-management-reports/view-stock-request.vue'], resolve)
      }
    ]
  },
  {
    path: '/stock-transfer-management-reports',
    component: resolve => require(['./views/stock-management-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/stock-management-reports/stock-transfer.vue'], resolve)
      },
      {
        name: 'view-stock-transfer',
        path: 'view-stock-transfer/:id',
        component: resolve => require(['./views/stock-management-reports/view-stock-transfer.vue'], resolve)
      }
    ]
  },
  {
    path: '/oos-report',
    component: resolve => require(['./views/oos-report/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/oos-report/index.vue'], resolve)
      },
      {
        name: 'filtered',
        path: 'filtered',
        component: resolve => require(['./views/oos-report/filtered.vue'], resolve)
      }
    ]
  },
  {
    path: '/order-form-report',
    component: resolve => require(['./views/order-form-report/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/order-form-report/index.vue'], resolve)
      },
      {
        name: 'filtered2',
        path: 'filtered',
        component: resolve => require(['./views/order-form-report/filtered.vue'], resolve)
      }
    ]
  },
  {
    path: '/sales-target-location',
    component: resolve => require(['./views/locationsalestarget/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/locationsalestarget/index.vue'], resolve)
      },
      {
        name: 'sales-target-location-edit',
        path: 'edit/:id',
        component: resolve => require(['./views/locationsalestarget/edit.vue'], resolve)
      },
      {
        name: 'sales-target-location-add',
        path: 'add',
        component: resolve => require(['./views/locationsalestarget/add.vue'], resolve)
      }
    ]
  },
  {
    path: '/sales-target-promoter',
    component: resolve => require(['./views/promotersalestarget/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/promotersalestarget/index.vue'], resolve)
      },
      {
        name: 'sales-target-promoter-edit',
        path: 'edit/:id',
        component: resolve => require(['./views/promotersalestarget/edit.vue'], resolve)
      },
      {
        name: 'sales-target-promoter-add',
        path: 'add',
        component: resolve => require(['./views/promotersalestarget/add.vue'], resolve)

      }
    ]
  },
  { path: '/welcome', component: resolve => require(['./views/Welcome.vue'], resolve) },
  {
    path: '/company',
    component: resolve => require(['./views/company/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/company/index.vue'], resolve)
      },
      {
        name: 'add-company',
        path: 'add',
        component: resolve => require(['./views/company/add.vue'], resolve)
      },
      {
        name: 'edit-company',
        path: 'edit/:id',
        component: resolve => require(['./views/company/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/usersadmin',
    component: resolve => require(['./views/usersadmin/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/usersadmin/index.vue'], resolve)
      },
      {
        name: 'admin-add-user',
        path: 'add',
        component: resolve => require(['./views/usersadmin/add.vue'], resolve)
      },
      {
        name: 'admin-edit-user',
        path: 'edit/:id',
        component: resolve => require(['./views/usersadmin/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/clientusers',
    component: resolve => require(['./views/clientusers/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/clientusers/index.vue'], resolve)
      },
      {
        name: 'add-clientusers',
        path: 'add',
        component: resolve => require(['./views/clientusers/add.vue'], resolve)
      },
      {
        name: 'edit-clientusers',
        path: 'edit/:id',
        component: resolve => require(['./views/clientusers/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/store-audit-report',
    component: resolve => require(['./views/store-audit-report/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/store-audit-report/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/master-visit-report',
    component: resolve => require(['./views/master-visit-report/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/master-visit-report/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/promoter-roster-report',
    component: resolve => require(['./views/promoter-roster-report/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/promoter-roster-report/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/planograms',
    component: resolve => require(['./views/planogram/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/planogram/index.vue'], resolve)
      },
      {
        path: 'add',
        component: resolve => require(['./views/planogram/add.vue'], resolve)
      },
      {
        name: 'edit-planogram',
        path: 'edit/:id',
        component: resolve => require(['./views/planogram/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/planogram-location',
    component: resolve => require(['./views/planogram-location/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/planogram-location/index.vue'], resolve)
      },
      {
        name: 'add-planogram-location',
        path: 'add',
        component: resolve => require(['./views/planogram-location/add.vue'], resolve)
      }
    ]
  },
  {
    path: '/no-visit-location-report',
    component: resolve => require(['./views/location-report/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/location-report/index.vue'], resolve)
      },
      {
        name: 'filtered3',
        path: 'filtered',
        component: resolve => require(['./views/location-report/filtered.vue'], resolve)
      }
    ]
  },
  {
    path: '/commission-report',
    component: resolve => require(['./views/commissionreport/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/commissionreport/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/task-report',
    component: resolve => require(['./views/task-report/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/task-report/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/historical-taskreport',
    component: resolve => require(['./views/task-report/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/task-report/historical.vue'], resolve)
      }
    ]
  },
  {
    path: '/customers',
    component: resolve => require(['./views/customers/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/customers/index.vue'], resolve)
      },
      {
        name: 'add-customer',
        path: 'add',
        component: resolve => require(['./views/customers/add.vue'], resolve)
      },
      {
        name: 'edit-customer',
        path: 'edit/:id',
        component: resolve => require(['./views/customers/edit.vue'], resolve)
      }
    ]
  },
  {
    path: '/discrepancy-report',
    component: resolve => require(['./views/discrepancy-report/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/discrepancy-report/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/stock-receipt-erp-management-reports',
    component: resolve => require(['./views/stock-management-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/stock-management-reports/stock-receipt-erp.vue'], resolve)
      },
      {
        name: 'view-stock-receipt-erp',
        path: 'view-stock-receipt-erp/:id',
        component: resolve => require(['./views/stock-management-reports/view-stock-receipt-erp.vue'], resolve)
      }
    ]
  },
  {
    path: '/retailer-execution',
    component: resolve => require(['./views/retailer-execution/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/retailer-execution/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/sales-dashboard',
    component: resolve => require(['./views/sales-dashboard/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/sales-dashboard/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/stock-management-dashboard',
    component: resolve => require(['./views/stock-take-dashboard/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/stock-take-dashboard/index.vue'], resolve)
      }
    ]
  },
  {
    path: '/sampling-reports',
    component: resolve => require(['./views/sampling-reports/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/sampling-reports/sampling-reports.vue'], resolve)
      }
    ]
  },
  {
    path: '/assign-supervisor',
    component: resolve => require(['./views/assign_supervisor/template.vue'], resolve),
    children: [
      {
        path: '',
        component: resolve => require(['./views/assign_supervisor/index.vue'], resolve)
      },
      {
        name: 'add-assign-supervisor',
        path: 'add',
        component: resolve => require(['./views/assign_supervisor/add.vue'], resolve)
      }
    ]
  },

  { path: '*', component: NotFound }
]



// WEBPACK FOOTER //
// ./src/routes.js